module.exports = __webpack_public_path__ + "img/i_homework-unfinished.f544c4bb.svg";